import React, { useEffect, useRef, useState } from 'react';
import { observer } from 'mobx-react-lite';
import Paths from '../../constants/paths';
import { useHistory } from 'react-router-dom';
import useModal from '../../customHooks/useModal';
import Button from '../../components/Button';
import { FaTrash, FaPlus, FaSearch } from 'react-icons/fa';
import Table from '../../components/Table';
import Modal from '../../components/Modal';
import Input from '../../components/Input';
import Pagination from './../../components/Pagination';
import debounce from 'lodash.debounce';
import translations from '../../translations/de';

const SeatMaps = ({ store }) => {
    const history = useHistory();
    const modalRef = useRef(null);
    const [modal, setModal] = useModal(false, modalRef);
    const [seatMapID, setSeatMapID] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');

    useEffect(() => {
        store.getSeatMaps(searchQuery);
    }, [store, store.selectedPage, searchQuery]);

    const handleSeatMap = (id) => {
        store.selectSeatMap(id);
        history.push(`/seat-maps/${store.selectedSeatMap.id}`);
    };

    const onSearchChangeHandler = debounce((e) => {
        store.setSelectedPage(1);
        setSearchQuery(e.target.value);
    }, 500);

    return (
        <>
            <div style={{ marginLeft: '2.5%' }}>
                <Input placeholder={translations.search} onChange={onSearchChangeHandler} />
                <Button
                    label={translations.seat_assignment}
                    onClick={() => {
                        store.selectSeatMap(undefined);
                        history.push(Paths.NEW_SEAT_MAP);
                    }}
                >
                    <FaPlus style={{ marginRight: '5px' }} />
                </Button>
            </div>
            <Table
                tablePagination={
                    store.totalPages > 1 && (
                        <Pagination
                            totalPages={store.totalPages}
                            selectedPage={store.selectedPage}
                            onSelectedPageChange={(selected) => store.setSelectedPage(selected)}
                        />
                    )
                }
                tableName={translations.seat_assignments}
                columns={[
                    {
                        Header: 'Id',
                        accessor: 'id',
                        Cell: ({ value, row }) => <div>{value}</div>,
                    },
                    {
                        Header: `${translations.original_seat} (id/${translations.row}/${translations.number})`,
                        accessor: 'original_seat_id',
                        Cell: ({ value, row }) => <div>{value}</div>,
                    },
                    {
                        Header: `${translations.assigned_seat} (id/${translations.row}/${translations.number})`,
                        accessor: 'mapped_seat_id',
                        Cell: ({ value, row }) => <div>{value}</div>,
                    },
                    {
                        Header: translations.scenario,
                        accessor: 'scenario_id',
                        Cell: ({ value, row }) => <div>{value}</div>,
                    },
                    {
                        Header: '',
                        accessor: 'action',
                        Cell: ({ row }) => (
                            <div>
                                <Button
                                    onClick={() => {
                                        handleSeatMap(row.cells[0].value);
                                    }}
                                    title={translations.show}
                                >
                                    <FaSearch />
                                </Button>
                                <Button
                                    onClick={() => {
                                        setSeatMapID(row.cells[0].value);
                                        setModal(true);
                                    }}
                                    title={translations.delete}
                                >
                                    <FaTrash />
                                </Button>
                            </div>
                        ),
                    },
                ]}
                data={store.seatMaps.map(({ id, original_seat, mapped_seat, scenario_id }) => {
                    return {
                        id: id,
                        original_seat_id: `${original_seat.id}/${original_seat.row}/${original_seat.num}`,
                        mapped_seat_id: `${mapped_seat.id}/${mapped_seat.row}/${mapped_seat.num}`,
                        scenario_id: scenario_id,
                    };
                })}
            />
            {modal && (
                <Modal
                    title="Delete Seat Group"
                    ref={modalRef}
                    onClose={() => setModal(false)}
                    maxWidth="400px"
                >
                    <p style={{ color: '#333', marginBottom: '20px' }}>
                        Are you sure you want to delete this seat map?
                    </p>
                    <div className="Modal-Controls">
                        <Button
                            label="Yes"
                            onClick={() => {
                                store.deleteSeatMap(seatMapID);
                                setModal(false);
                            }}
                            style={{ width: '80px' }}
                        />
                        <Button
                            label="No"
                            onClick={() => setModal(false)}
                            style={{ width: '80px', marginLeft: '20px' }}
                        />
                    </div>
                </Modal>
            )}
        </>
    );
};
export default observer(SeatMaps);
